import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const DigitalSignatureLazy = lazyLoader(
  () =>
    import('./DigitalSignature' /* webpackChunkName: "digital-signature" */),
);

const DigitalSignatureComponent = () => {
  return (
    <Suspense fallback={null}>
      <DigitalSignatureLazy />
    </Suspense>
  );
};

export default DigitalSignatureComponent;
